import axios from 'axios';

export async function getPolicyAndTerms(lang) {
  return (await axios.post(`/policy-terms`, {
    lang, type: 'text/html'
  }))
}
